export default function LabelForm({ label, children }) {
  return (
    <div>
      <div style={{ fontSize: "14px", marginBottom: "6px" }}>{label}</div>

      <div style={{ fontSize: "16px" }}>{children}</div>
    </div>
  );
}
